export default __webpack_public_path__ + "static/media/MutualofOmaha.acb0c8f8.svg";